module.exports = __webpack_public_path__ + "static/earth_elemental-a0b4295789545b94141f035183ab8de8.jpg";